$(document).ready(function () {


$(document).on("click", ".prd_dynamic_cart", function (e) {
  e.preventDefault();

  var $btn = $(this);
  var varId = $btn.data("varid");

  // Add loading class
  $btn.addClass("is--loading");

  // Example AJAX request
  $.ajax({
    url: "/cart/add.js",
    type: "POST",
    data: {
      id: varId,
      quantity: 1
    },
    dataType: "json",
    success: function (res) {
      // Fetch updated cart
      $.getJSON("/cart.js", function (cart) {
        // Update header cart count
        $("span[data-header-cart-count]").text(cart.item_count);
      });

      $btn.removeClass("is--loading");
    },
    error: function (xhr) {
      console.error("Error:", xhr);

      // Remove loading class on error too
      $btn.removeClass("is--loading");
    }
  });
});


//Site 1 Marquee slider
    if($("#slider--top").length != 0) {

        new Splide("#slider--top", {
            type: "loop",
            autoWidth: true,
            autoplay: true,
            interval: 1,
            speed: 100000,
            direction: "ltr",
            arrows: false,
            pagination: false,
            pauseOnHover: false,
            pauseOnFocus: false,
            gap: '50px'
        }).mount();
    }
//Site 1 Featured collection product slider
    if($(".prod-slider").length != 0) {

    new Splide('.prod-slider', {
     type: "loop",
    perPage: 3,
    autoplay: true,
     interval: 5000,
    gap: '100px',
    arrows: true,
    pagination: false,
    breakpoints: {
      768: { perPage: 1 },
      1024: { perPage: 3 }
    }
  }).mount();
}

  
//TEstimonaials Video Slider 
    if($(".reviews-sec .videos-grid").length != 0) {

              new Splide('.reviews-sec .videos-grid', {
                perPage: 3,
                drag: false,
dragAngleThreshold: 0,
                gap: '55px',
                arrows: false,
                autoplay: false,
                pagination: true,
                breakpoints: {
                    500: { perPage: 1,
                            drag: true
                    },
                    820: { perPage: 2,
                      drag: true,
                         gap: '45px'
                     }
                }
            }).mount();
        }


//TEstimonaials Review Slider 
    if($(".testimonials-slider").length != 0) {

   new Splide('.testimonials-slider', {
        perPage: 3,
        gap: '45px',
        arrows: true,
        autoplay: false,
         interval: 1000,
        pagination: false,
        breakpoints: {
            768: { perPage: 1 },
            1024: { perPage: 2 }
        }
    }).mount();
}

    if($(".reviews-sec").length != 0) {

        //TEstimonaials On play button click play video and overlay
        document.querySelectorAll(".reviews-sec").forEach(function (reviewsSec) {
        const videos = reviewsSec.querySelectorAll(".video-element");

        videos.forEach(function (video) {
            let overlay = video.parentElement.querySelector(".overlay-content");

            if (overlay) {
            // Function to pause other videos
            function pauseOthers() {
                videos.forEach(function (otherVideo) {
                if (otherVideo !== video) {
                    otherVideo.pause();
                    let otherOverlay = otherVideo.parentElement.querySelector(".overlay-content");
                    if (otherOverlay) otherOverlay.style.display = "";
                }
                });
            }

            // Click overlay → play video + hide overlay
            overlay.addEventListener("click", function () {
                pauseOthers();
                video.play();
                overlay.style.display = "none";
            });

            // Click video → toggle pause/play
            // video.addEventListener("click", function () {
            //     if (!video.paused) {
            //     // Pause current video and restore overlay
            //     video.pause();
            //     overlay.style.display = "";
            //     }
            // });

            // When video pauses → show overlay
            video.addEventListener("pause", function () {
                overlay.style.display = "";
            });

            // When video ends → show overlay again
            video.addEventListener("ended", function () {
                overlay.style.display = "";
            });
            }
        });
        });
    }

    //Custom Search icon header on click trigger search form
    if($(".site1_header_serach_frm .site-search-handle").length != 0) {
        document.querySelector('.site1_header_serach_frm .site-search-handle')?.addEventListener('click', function (e) {
            e.preventDefault();
                const mobileSearchElements = document.querySelectorAll('.site1_pages .mobile-left-icons .site-search-handle');
                
                if (mobileSearchElements.length > 0) {
                
                    mobileSearchElements.forEach(el => {
                        
                        el.dispatchEvent(new MouseEvent('click', {
                            bubbles: true,
                            cancelable: true,
                            view: window
                        }));
                    });
                }

        });
    }
});


gsap.registerPlugin(ScrollTrigger);
 
gsap.fromTo(
    [".point-1", ".point-2", ".point-3"],
    { x: -50, opacity: 0 },
    {
        x: 0,
        opacity: 1,
        duration: 0.6,
        stagger: 0.3,
        ease: "power2.out",
        scrollTrigger: {
            trigger: ".prod-left",
            start: "top 80%",  
            toggleActions: "play none none none",
           
        }
    }
);
 
gsap.fromTo(
    [".point-4", ".point-5", ".point-6"],
    { x: 50, opacity: 0 },
    {
        x: 0,
        opacity: 1,
        duration: 0.6,
        stagger: 0.3,
        ease: "power2.out",
        delay: 0.9,
        scrollTrigger: {
            trigger: ".prod-left",
            start: "top 80%",
            toggleActions: "play none none none",
           
        }
    }
);

gsap.registerPlugin(ScrollTrigger);

gsap.utils.toArray('.shopify-section').forEach(section => {
  const headings = section.querySelectorAll('h2');
  
  headings.forEach(heading => {
    gsap.from(heading, {
      opacity: 0,
      y: 30,
      duration: 1,
      scrollTrigger: {
        trigger: heading,       
        start: "top 80%",       
        toggleActions: "play none none none"
      }
    });
  });
});



$(document).ready(function () {
    if($("#thumbnail-slider").length != 0) {
        var thumbs = new Splide('#thumbnail-slider', {
           perPage: 5,
            fixedWidth   : 80,
            fixedHeight  : 80,
            gap          : 10,
            pagination   : false,
            direction    : 'ttb',   // vertical
            height       : '500px',
            focus        : 'center', 
            isNavigation : true,    
            breakpoints: {
            820: { perPage: 4, height : '400px', },
            767: {  direction    : 'ltr', perPage: 4, height : 'auto' }
        } 
    
        });

        thumbs.on('moved', function (newIndex) {
            // get the active slide
            var activeSlide = thumbs.Components.Slides.getAt(newIndex).slide;
            var mediaId = activeSlide.getAttribute('data-mediaId');
            var targetBtn = document.querySelector(
                '.product-gallery__thumbnails button[data-mediaId="' + mediaId + '"]'
            );

            if (targetBtn) {
                targetBtn.click();
                console.log('Triggered click on button with mediaId:', mediaId);
            }

            // NEW: also force the main image to update (css-slider aware)
            var imgEl = activeSlide.querySelector('img');
            var srcEl = imgEl && (imgEl.currentSrc || imgEl.src);
            if (srcEl && window._site1ActivateMainByImgSrc) {
                window._site1ActivateMainByImgSrc(srcEl);
            }
        });

        thumbs.mount();
        window._site1Thumbs = thumbs;

            if (typeof mediaactiveId !== 'undefined' && mediaactiveId) {
            
                // Auto-activate current variant media
                    var targetIndex = [...document.querySelectorAll('#thumbnail-slider .splide__slide')]
                    .findIndex(el => el.dataset.mediaId === mediaactiveId);
                    if (targetIndex >= 0) {
                    thumbs.go(targetIndex);
                    }
                }
    }
});

/* NEW: Sync main image when any native product thumbnail is clicked */
document.addEventListener('click', function(e){
  var btn = e.target.closest('.product-gallery__thumbnails button');
  if (!btn) return;
  var img = btn.querySelector('img');
  var src = img && (img.currentSrc || img.src);
  if (src && window._site1ActivateMainByImgSrc){
    window._site1ActivateMainByImgSrc(src);
  }
});

/* NEW: Also handle clicks inside our Splide thumbnail rail */
document.addEventListener('click', function(e){
  var slide = e.target.closest('#thumbnail-slider .splide__slide');
  if (!slide) return;
  var img = slide.querySelector('img');
  var src = img && (img.currentSrc || img.src);
  if (src && window._site1ActivateMainByImgSrc){
    window._site1ActivateMainByImgSrc(src);
  }
});

    // modal
      const modal = document.getElementById('cm_modal');
      const closeEls = modal.querySelectorAll('[data-close]');
      let lastFocused = null;

      const FOCUSABLE = 'a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), [tabindex]:not([tabindex="-1"])';

      function openCmModal(selector_content) {
        if(selector_content){
            
            const selector_contentEl = document.querySelector(selector_content);
            const cm_modal__content = document.querySelector('.cm_modal__content');
            cm_modal__content.innerHTML="";
            if(selector_contentEl){
                  cm_modal__content.innerHTML=selector_contentEl.innerHTML;
            }
        }
        lastFocused = document.activeElement;
        modal.classList.add('is-open');
        modal.removeAttribute('aria-hidden');
        // move focus inside
        const first = modal.querySelector(FOCUSABLE);
        if (first) first.focus();
        document.addEventListener('keydown', onCmKeydown);
      }

      function closeCmModal() {
        modal.classList.remove('is-open');
        modal.setAttribute('aria-hidden', 'true');
        document.removeEventListener('keydown', onCmKeydown);
        if (lastFocused) lastFocused.focus();
      }

      function onCmKeydown(e) {
        if (e.key === 'Escape') return closeCmModal();
        if (e.key === 'Tab') trapCmFocus(e);
      }

      function trapCmFocus(e) {
        const focusables = modal.querySelectorAll(FOCUSABLE);
        if (!focusables.length) return;
        const first = focusables[0];
        const last = focusables[focusables.length - 1];
        if (e.shiftKey && document.activeElement === first) {
          e.preventDefault();
          last.focus();
        } else if (!e.shiftKey && document.activeElement === last) {
          e.preventDefault();
          first.focus();
        }
      }

      closeEls.forEach(el => el.addEventListener('click', closeCmModal));
      // Prevent clicks inside the dialog from bubbling to overlay
      modal.querySelector('.cm_modal__dialog').addEventListener('click', (e) => e.stopPropagation());
      // Clicking overlay closes
      modal.addEventListener('click', (e) => {
        if (e.target.hasAttribute('data-close')) closeCmModal();
      });


//Add to cart custom with subcription plan

document.addEventListener("DOMContentLoaded", function () {
  const qtyDropdowns = document.querySelectorAll(".cm-variant-qty");

  qtyDropdowns.forEach(function (dropdown) {
    dropdown.addEventListener("change", function (e) {
      const pgbar_response = document.querySelector("#pgbar_response");
      const currentquantity = parseInt(pgbar_response.getAttribute("data-cartcount"), 10) || 0;
      
        let hasValidQty = 0;

        // 3. Loop over all qty inputs
        document.querySelectorAll(".cm-variant-qty").forEach(function (qtyInput) {
          const qty = parseInt(qtyInput.value, 10) || 0;
          const itemIndex = qtyInput.getAttribute("data-index");
          const itemWrapper = qtyInput.closest(".cm-variant-item");
          const variantId = itemWrapper ? itemWrapper.getAttribute("data-variant-id") : null;

          if (!variantId) return;

          if (qty > 0) {
            hasValidQty = hasValidQty + qty;
                    }
        });
        
        // pgbar_response.innerHTML = hasValidQty + currentquantity;
        pgbar_response.setAttribute("data-cartcount", hasValidQty + currentquantity);

        
      

    });
  });





  document.querySelectorAll(".cm-add-to-cart").forEach(function (btn) {
    btn.addEventListener("click", function (e) {
      e.preventDefault();
      document.querySelectorAll('.custom-error-message').forEach(el => el.remove());

      // 1. Find parent form
      const form = btn.closest("form");
      if (!form) return;
      // Check Recharge widget radio buttons
      const rcInput = form.querySelector(".rc_widget__option__input:checked");
      const inputContainer = form.querySelector(".cm-variants-grid-container");
      if(inputContainer){
        inputContainer.classList.remove("is--error");
      }
      let sellingplan = "";

      // If Recharge radio buttons exist
      if (rcInput) {
        if (rcInput.value == "onetime") {
          sellingplan = ""; // force one-time → no selling plan
        } else {
          // fallback to dropdown selection
          const dropdown = form.querySelector("select.rc-selling-plans__dropdown");
          sellingplan = dropdown ? dropdown.value : "";
        }
      } else {
        // No radio widget, fallback to dropdown
        const dropdown = form.querySelector("select.rc-selling-plans__dropdown");
        sellingplan = dropdown ? dropdown.value : "";
      }

    

      let hasValidQty = false;
      let items = [];

      // 3. Loop over all qty inputs
      form.querySelectorAll(".cm-variant-qty").forEach(function (qtyInput) {
        const qty = parseInt(qtyInput.value, 10) || 0;
        const itemIndex = qtyInput.getAttribute("data-index");
        const itemWrapper = qtyInput.closest(".cm-variant-item");
        const variantId = itemWrapper ? itemWrapper.getAttribute("data-variant-id") : null;

        if (!variantId) return;

        if (qty > 0) {
          hasValidQty = true;
           let item = {
            id: variantId,
            quantity: qty
          };

          if (sellingplan) {
            item.selling_plan = sellingplan;
          }
      

          items.push(item);
        }
      });
      // 4. If all quantities <= 0, alert
      if (!hasValidQty) {
     
            if(inputContainer){
              inputContainer.classList.add("is--error");
              inputContainer.scrollIntoView({
                behavior: 'smooth', // smooth scrolling animation
                block: 'start'      // align the top of element with the top of viewport
              });
            }

              const errorEl = document.createElement('div');
              errorEl.className = 'custom-error-message';
              errorEl.textContent = 'Please select at least one item with quantity greater than 0.';

              // Optional styling
              errorEl.style.color = 'red';
              errorEl.style.marginBottom = '10px';
              errorEl.style.fontWeight = '500';

              // Insert before the button
              btn.parentNode.insertBefore(errorEl, btn);       
        return;
      }
             btn.classList.add("is--loading");
            // 5. Add to cart via fetch
            fetch(window.Shopify.routes.root + "cart/add.js", {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
              },
              body: JSON.stringify({ items })
            })
              .then((res) => res.json())
              .then((data) => {
                  //  btn.classList.remove("is--loading");
                    window.location.href = "/cart";
              })
              .catch((err) => {
                btn.classList.remove("is--loading");
                const errorEl = document.createElement('div');
                errorEl.className = 'custom-error-message';
                errorEl.textContent = 'Something went wrong. Please try again.';

                // Optional styling
                errorEl.style.color = 'red';
                errorEl.style.marginBottom = '10px';
                errorEl.style.fontWeight = '500';

                // Insert before the button
                btn.parentNode.insertBefore(errorEl, btn);
              // alert("Something went wrong. Please try again.");
              });
    });
  });
});


document.querySelectorAll('a[href*="#faqs-section"]').forEach(link => {
  link.addEventListener('click', e => {
       var checkfaq = movetofaq();
        if(!checkfaq){
              e.preventDefault();

        }
  });
});

// Helper: check if header visible
function isElementInViewport(el) {
  const rect = el.getBoundingClientRect();
  return rect.bottom > 0 && rect.top < window.innerHeight;
}

// Helper: check if header visible
function movetofaq() {
 
     const faqItems = document.querySelector('.faq-items .faq_text_container');
      if (!faqItems) return true;
      document.querySelector('.sidebar__close')?.click();

      // Calculate top offset
      const header = document.querySelector('#site-header');
      const headerHeight = header && header.offsetHeight && isElementInViewport(header)
        ? header.offsetHeight
        : 0;

      const offsetTop = faqItems.getBoundingClientRect().top + window.scrollY - headerHeight;

      // Smooth scroll
      window.scrollTo({
        top: offsetTop,
        behavior: 'smooth'
      });

      // Animate first FAQ item
      const firstItem = faqItems.firstElementChild;
      if (firstItem) {
        firstItem.classList.add('highlight-anim');
        setTimeout(() => firstItem.classList.remove('highlight-anim'), 1200);
      }
      return false;
}

document.addEventListener("DOMContentLoaded", function () {

if (window.location.hash === '#faqs-section') {
  var checkfaq = movetofaq();
    if(!checkfaq){
        console.log("checkfaq",checkfaq);

    }
}
});

/*********************
 FREEBIES PROGRESS BAR CONTROLLER
 - does NOT replace existing listeners
 - just adds its own listeners + updater
*********************/
document.addEventListener("DOMContentLoaded", function () {

  // 1. Get total qty selected in the multi-variant grid
  function getSelectedQtyTotal() {
    var total = 0;
    document.querySelectorAll(".cm-variant-qty").forEach(function (qtyInput) {
      var qty = parseInt(qtyInput.value, 10) || 0;
      total += qty;
    });
    return total;
  }

  // 2. Update the text + image under the Key Benefits section
  function updateFreebiesProgressUI() {
    var wrapper = document.querySelector("#pgbar_response");
    if (!wrapper) return; // if that block doesn't exist on this page, bail

    var msgEl = document.getElementById("freebies_progress_msg");
    var imgEl = document.getElementById("freebies_progress_img");
    if (!msgEl || !imgEl) return;

    var totalQty = getSelectedQtyTotal();

    // Rules:
    // qty = 0 → "Buy 2 more to get free shipping"
    // qty = 1 → "Buy 1 more to get free shipping"
    // qty = 2 → "Add one more bag to get 10% off"
    // qty = 3 → "Buy 1 more to get Free Samples"
    // qty >=4 → "Congratulations!🎉 You've earned Free Shipping, 10% Discount, and Free Samples!"

    if (totalQty >= 4) {
      msgEl.textContent =
        "Congratulations!🎉 You've earned Free Shipping, 10% Discount, and Free Samples!";
      imgEl.src =
        "https://cdn.shopify.com/s/files/1/0019/0257/5669/files/pb5_Congratulations_You_ve_earned_Free_Shipping_10_Discount_and_Free_Samples.png?v=1761716346";
    } else if (totalQty === 3) {
      msgEl.textContent = "Buy 1 more to get Free Samples";
      imgEl.src =
        "https://cdn.shopify.com/s/files/1/0019/0257/5669/files/pb4_Buy_1_more_to_get_Free_Samples.png?v=1761716344";
    } else if (totalQty === 2) {
      msgEl.textContent = "Add one more bag to get 10% off";
      imgEl.src =
        "https://cdn.shopify.com/s/files/1/0019/0257/5669/files/pb3_Add_one_more_bag_to_get_10_off.png?v=1761716342";
    } else if (totalQty === 1) {
      msgEl.textContent = "Buy 1 more to get free shipping";
      imgEl.src =
        "https://cdn.shopify.com/s/files/1/0019/0257/5669/files/pb2_Buy_1_more_to_get_free_shipping.png?v=1761716338";
    } else {
      // totalQty === 0 or anything invalid
      msgEl.textContent = "Buy 2 more to get free shipping";
      imgEl.src =
        "https://cdn.shopify.com/s/files/1/0019/0257/5669/files/pb1_Buy_2_more_to_get_free_shipping.png?v=1761716335";
    }
  }

  // 3. Watch all qty dropdowns for change and refresh progress bar
  function attachQtyListeners() {
    document.querySelectorAll(".cm-variant-qty").forEach(function (dropdown) {
      dropdown.addEventListener("change", function () {
        updateFreebiesProgressUI();
      });
    });
  }

  // 4. Initialize on load
  attachQtyListeners();
  updateFreebiesProgressUI();
});

// ===== HPN: Preselect variant via ?preselect=VARIANT_ID, else default Banana Maple =====
(function preselectOrDefaultQty(){
  // Fallback default → Banana Maple French Toast
  var FALLBACK_DEFAULT_VARIANT_ID = '40461385531477';

  // Read ?preselect=123 from URL (only digits allowed)
  var urlParams = new URLSearchParams(window.location.search);
  var paramId = urlParams.get('preselect');
  var PRESELECT_ID = (paramId && /^\d+$/.test(paramId)) ? paramId : null;

  function setQtyOneIfZeroByVariantId(variantId){
    if (!variantId) return false;
    var item = document.querySelector('.cm-variant-item[data-variant-id="' + variantId + '"]');
    if (!item) return false;
    var qtyEl = item.querySelector('.cm-variant-qty');
    if (!qtyEl) return false;
    var curr = parseInt(qtyEl.value, 10) || 0;
    if (curr < 1){
      qtyEl.value = '1';
      // trigger change so all listeners (progress bar, image switcher) update
      qtyEl.dispatchEvent(new Event('change', { bubbles: true }));
    }
    return true;
  }

  function init(){
    // If a valid preselect is present AND we can find that variant, use it and stop.
    if (PRESELECT_ID && setQtyOneIfZeroByVariantId(PRESELECT_ID)) {
      return;
    }
    // Else fallback to Banana Maple
    setQtyOneIfZeroByVariantId(FALLBACK_DEFAULT_VARIANT_ID);
  }

  if (document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();


// ===== HPN: Switch main gallery image when qty is set (>0) for a variant [v2 robust] =====
(function variantQtyImageSwitcherV2(){
  // Map Variant ID -> unique image slug (substring in its CDN URL)
  var VARIANT_IMG_SLUG = {
    "40461385531477": "BananaMapleFrenchToast",
    "40472683675733": "ChocolateCaramelCandyBar_97b05662-1916-4077-9b4b-0770e21c0884",
    "40549946589269": "CinnamonRoll",
    "40550495191125": "MadagascarVanilla_891ff9ac-ad16-4498-908a-35304225ea3f",
    "40613658165333": "MeltedChocolate_7be8f52b-db42-405a-85b2-030da2d61d66",
    "40722836947029": "StrawberryIceCream_1d9b8de5-7102-4bca-9aee-96d48f9797a7"
  };

  // 1) Prefer moving the Splide thumbnail rail
  function goThumbBySlug(slug){
    try{
      if (!window._site1Thumbs || !slug) return false;
      var slides = document.querySelectorAll('#thumbnail-slider .splide__slide');
      if (!slides.length) return false;

      var targetIndex = -1;
      for (var i=0;i<slides.length;i++){
        var img = slides[i].querySelector('img');
        if (img && (img.currentSrc || img.src)){
          var src = img.currentSrc || img.src;
          if (src.indexOf(slug) !== -1){ targetIndex = i; break; }
        }
      }
      if (targetIndex >= 0){
        window._site1Thumbs.go(targetIndex);
        return true;
      }
    }catch(e){}
    return false;
  }

  // 2) Fallbacks if Splide not available
  function switchMainSrc(src){
    if (!src) return;
    var mainImg =
      document.querySelector('.product-gallery__main img') ||
      document.querySelector('.product__media img') ||
      document.querySelector('.product__media-item img') ||
      document.querySelector('.product__main-photos img') ||
      document.querySelector('#ProductPhotos img') ||
      document.querySelector('.product-gallery img');
    if (mainImg){
      mainImg.src = src;
      if (mainImg.srcset) mainImg.srcset = src;
    }
  }

  // NEW: Switch the main CSS Slider panel by image slug
  function activateCssSliderBySlug(slug){
    try{
      if (!slug) return false;

      // Prefer the product gallery css-slider; fallback to any css-slider with product-gallery-item
      var slider =
        document.querySelector('.product-gallery .css-slider.enabled') ||
        document.querySelector('#css-slider-template--16506549829717__main') ||
        document.querySelector('.css-slider.enabled');

      if (!slider) return false;

      // Grab slides inside the css-slider
      var slides = slider.querySelectorAll('.product-gallery-item.css-slide, .product-gallery-item');
      if (!slides.length) return false;

      // Find the slide whose <img> src/srcset contains the slug
      var target = null;
      slides.forEach(function(slide){
        var img = slide.querySelector('img');
        var src = (img && (img.currentSrc || img.src)) || '';
        if (!target && src.indexOf(slug) !== -1) target = slide;
      });
      if (!target) return false;

      // Toggle active class
      slider.querySelectorAll('.css-slide-active').forEach(function(s){ s.classList.remove('css-slide-active'); });
      target.classList.add('css-slide-active');

      // Ensure it scrolls into view (most css-slider setups use scroll-snap)
      if (target.scrollIntoView) target.scrollIntoView({ block: 'nearest', inline: 'center' });

      // If viewport exists, snap horizontally
      var viewport = slider.querySelector('.css-slider-viewport');
      if (viewport && typeof viewport.scrollTo === 'function') {
        viewport.scrollTo({ left: target.offsetLeft, behavior: 'auto' });
      }

      return true;
    } catch(e){
      // fail silent → let other fallbacks run
      return false;
    }
  }

    // NEW: global helper to switch main image from a full <img> URL
  window._site1ActivateMainByImgSrc = function(src){
    if (!src) return false;
    // try filename slug (works with your css-slider matcher)
    var slug = src.split('/').pop().split('?')[0];
    if (activateCssSliderBySlug(slug)) return true;
    // fallback: hard swap the main <img> if present
    switchMainSrc(src);
    return true;
  };


  function switchMainImageBySlug(slug){
    if (activateCssSliderBySlug(slug)) return;

    if (!slug) return;

    // A) Try Splide rail jump
    if (goThumbBySlug(slug)) return;

    // B) Try native thumbs
    var nativeThumb = document.querySelector('.product-gallery__thumbnails img[src*="'+ slug +'"]');
    if (nativeThumb){
      var btn = nativeThumb.closest('button');
      if (btn){ btn.click(); return; }
      switchMainSrc(nativeThumb.currentSrc || nativeThumb.src);
      return;
    }

    // C) Last resort: any image on the page with this slug
    var anyImg = document.querySelector('img[src*="'+ slug +'"]');
    if (anyImg){
      switchMainSrc(anyImg.currentSrc || anyImg.src);
    }
  }

  function handleQtyChange(target){
    if (!target || !target.matches('.cm-variant-qty')) return;
    var qty = parseInt(target.value, 10) || 0;
    if (qty <= 0) return;
    var item = target.closest('.cm-variant-item');
    var variantId = item && item.getAttribute('data-variant-id');
    var slug = VARIANT_IMG_SLUG[variantId];
    switchMainImageBySlug(slug);
  }

  // Change listener for qty selects
  document.addEventListener('change', function(e){
    handleQtyChange(e.target);
  });

  // On load, if any qty > 0 (e.g., your default Banana Maple 1), sync image
  function syncOnLoad(){
    var firstPositive = null;
    document.querySelectorAll('.cm-variant-qty').forEach(function(q){
      var v = parseInt(q.value,10) || 0;
      if (!firstPositive && v > 0) firstPositive = q;
    });
    if (firstPositive) handleQtyChange(firstPositive);
  }

  if (document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', syncOnLoad);
  } else {
    syncOnLoad();
  }
})();
